import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Add error boundary for production
if (import.meta.env.PROD) {
  window.addEventListener('error', (event) => {
    console.error('Global error caught:', event.error);
    // You could also send this to an error tracking service
  });
  
  // Add unhandled promise rejection handler
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
  });
}

// Add a timeout to detect if the app is taking too long to load
let appLoadTimeout: number | undefined = undefined;

if (import.meta.env.PROD) {
  appLoadTimeout = window.setTimeout(() => {
    const loadingElement = document.getElementById('loading-indicator');
    if (loadingElement) {
      loadingElement.innerHTML = `
        <div style="text-align: center; padding: 2rem;">
          <h2 style="color: #FF6B00; margin-bottom: 1rem;">Loading is taking longer than expected</h2>
          <p>Please try refreshing the page. If the problem persists, please contact support.</p>
          <button onclick="window.location.reload()" 
                  style="background: #FF6B00; color: white; border: none; padding: 0.5rem 1rem; 
                         border-radius: 4px; margin-top: 1rem; cursor: pointer;">
            Refresh Page
          </button>
        </div>
      `;
    }
  }, 15000); // 15 seconds timeout
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Clear the timeout when the app loads successfully
if (import.meta.env.PROD && appLoadTimeout !== undefined) {
  window.addEventListener('load', () => {
    clearTimeout(appLoadTimeout);
  });
}